<template>
    <div>
        <div id="msg-container">
            <p class="mb-0 py-3 text-center w-100 d-inline" v-if="isState('NC') && isSocialStudies()">
                <strong>North Carolina!</strong>
                We partnered with state teachers and curriculum directors to build North Carolina’s NEW Social Studies curriculum and fully align it with the NEW North Carolina Social Studies Standards.
                <strong>Check it out now!</strong>
            </p>

            <p class="mb-0 py-3 text-center w-100 d-inline" v-if="isState('VA') && isSocialStudies()">
                <strong>Note when ordering print and online</strong>: Your all new Virginia Social Studies print publications will not ship until October,<br/> but your curriculum will be available online once your order is complete.
            </p>

            <p v-if="isState('FL') && isScience() && isHomeschoolStore()">
                <strong>The new Science Studies Weekly has not yet been printed</strong>. Print publications will not ship until available.<br/> Your curriculum will be available <strong>online</strong> once your order is complete.
            </p>

        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "TempAvailabilityMessage",
    props: {
        short: {
            type: Boolean,
            default: false
        },
        message: {
            type: String,
            default: null,
        },
        subject: {
            type: String,
            default: 'social-studies'
        }
    },
    computed: {
        ...mapState({
            stateData: state => state.stateData.stateData,
        }),
        state() {
            return this.$store.getters.getSelectedState;
        },
    },
    methods: {
        isState(state) {
            console.log("state: ", this.$store.getters.getSelectedState);
            return this.$store.getters.getSelectedState === state;
        },
        isSubject(subject) {
            return this.subject === subject;
        },
        isSocialStudies() {
            return this.isSubject('social-studies');
        },
        isScience() {
            return this.isSubject('science');
        },
        isHomeschoolStore() {
            console.log("home: ", this.$store.getters.isHomeschoolStore);
            return this.$store.getters.isHomeschoolStore;
        },
        isWeekend() {
            let day = new Date().getDay();
            return day === 0 || day === 6;
        }
    }
}
</script>

<style scoped lang="scss">
#msg-container {
    background-color: white;
    color: red;
}
a:link {
    color: red;
}
a:visited {
    color: darkred;
}

</style>